import { ApiTableColumn } from '@e3dc-react/shell/Elements/ApiView/ApiView'
import { ShowRoom } from 'src/Libs/company-settings/models/showroom.model'
import CompanyShowRoomsMenu from 'src/Libs/company-settings/components/showrooms/CompanyShowRoomsMenu'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useCountryOptions } from '@e3dc-react/shell/Hooks/useCountryOptions'

const useShowroomTableColumns = (
  companyId: number,
  setLoading: (isLoading: boolean) => void,
  setError: (isError: boolean) => void
): {
  columnsLg: ApiTableColumn<ShowRoom>[]
  columnsSm: ApiTableColumn<ShowRoom>[]
} => {
  const { t } = useCustomTranslation()
  const { allCountries } = useCountryOptions()

  const columnsLg: ApiTableColumn<ShowRoom>[] = [
    {
      name: 'name',
      label: t('administration.companyManagement.showroom.table-columns.name'),
      value: (showRoom: ShowRoom) => showRoom.name,
    },
    {
      name: 'address',
      label: t('administration.companyManagement.showroom.table-columns.address'),
      value: (showRoom: ShowRoom) => showRoom.address,
    },
    {
      name: 'city',
      label: t('administration.companyManagement.showroom.table-columns.city'),
      value: (showRoom: ShowRoom) => showRoom.city,
    },
    {
      name: 'countryCode',
      label: t('administration.companyManagement.showroom.table-columns.land'),
      value: (showRoom: ShowRoom) => allCountries.find(({ value }) => value === showRoom.countryCode)?.label,
    },
    {
      name: 'phone',
      label: t('administration.companyManagement.showroom.table-columns.phone'),
      value: (showRoom: ShowRoom) => showRoom.phone,
    },
    {
      name: 'email',
      label: t('administration.companyManagement.showroom.table-columns.email'),
      value: (showRoom: ShowRoom) => showRoom.email,
    },
    {
      name: 'name',
      label: '',
      value: (showRoom: ShowRoom) => <CompanyShowRoomsMenu companyId={companyId} showRoom={showRoom} setLoading={setLoading} setError={setError} />,
    },
  ]

  const columnsSm: ApiTableColumn<ShowRoom>[] = [
    {
      name: 'name',
      label: t('administration.companyManagement.showroom.table-columns.name'),
      value: (showRoom: ShowRoom) => showRoom.name,
    },
    {
      name: 'city',
      label: t('administration.companyManagement.showroom.table-columns.city'),
      value: (showRoom: ShowRoom) => showRoom.city,
    },
    {
      name: 'name',
      label: '',
      value: (showRoom: ShowRoom) => <CompanyShowRoomsMenu companyId={companyId} showRoom={showRoom} setLoading={setLoading} setError={setError} />,
    },
  ]

  return { columnsLg, columnsSm }
}

export default useShowroomTableColumns
